import { call, put, takeLatest } from "redux-saga/effects";
import {
  FETCH_SURVEY_REQUEST,
  FETCH_SURVEY_SUCCESS,
  CREATE_SURVEY_SUCCESS,
  CREATE_SURVEY_REQUEST, CREATE_SURVEY_FAILURE,
} from "../Survey/types";
import * as apis from "../../network/apis/surveyApi";
import { showErrorMsg } from "../../utils/Helpers";

function* fetchSurveySaga(action) {
  try {
    const response = yield call(apis.fetchSurvey, action.payload);
    yield put({ type: FETCH_SURVEY_SUCCESS, payload: response.data });
  } catch (error) {
    yield error.response && showErrorMsg(error.response.data?.message);
  }
}

function* createSurveySaga({ payload }) {
  try {
    const response = yield call(apis.createSurvey, payload);
    yield put({ type: CREATE_SURVEY_SUCCESS, payload: response.data });
  } catch (error) {
    yield error.response && showErrorMsg(error.response.data?.message);
    yield put({ type: CREATE_SURVEY_FAILURE, error: error.response.status});

  }
}

export function* watchSurveySaga() {
  yield takeLatest(FETCH_SURVEY_REQUEST, fetchSurveySaga);
}

export function* watchCreateSurveySaga() {
  yield takeLatest(CREATE_SURVEY_REQUEST, createSurveySaga);
}
